import { useQuery } from '@tanstack/react-query';
import { ActiveUsersApiResponse } from "../../pages/Analytics";
import { IStartEndBody } from "../../utils/types";
import { apiClient } from '../api-manager-instance';

export const useGetFirstOpenData = ({
  startDate = "7daysAgo",
  endDate = "today",
}: IStartEndBody) =>
  useQuery({
    queryKey: ["get_first_open_data", startDate, endDate],
    queryFn: async (): Promise<ActiveUsersApiResponse> => {
      const body = {
        dateRanges: [{ startDate, endDate }],
        metrics: ["eventCount"],
        dimensions: ["eventName", "date"],
        filters: {
          filter: {
            fieldName: "eventName",
            stringFilter: { value: "first_open" },
          },
        },
      };
      const res = await apiClient.post("/analytics/get-runReport-events", body);
      return res.data;
    },
  });
